import { FETCH_QUERIES_NAME } from '@common/constants';
import { useQuery } from '@tanstack/react-query';
import { AxiosErrorResponse } from '@core/error.models';
import { getInfoAttachedOptionsAsync } from './infoAttached.services';
import { IDesignBriefInfoAttached } from './infoAttached.models';

export const useFetchInfoAttachedOptions = (enabled = true) => {
  return useQuery<IDesignBriefInfoAttached[] | undefined, AxiosErrorResponse>(
    [FETCH_QUERIES_NAME.INFO_ATTACHED_OPTIONS],
    async () => {
      const results = await getInfoAttachedOptionsAsync();
      return results.items;
    },
    {
      enabled,
    },
  );
};
